import { Box, BoxProps, Flex } from '@chakra-ui/react';

const SettingsTextContainer = (props: BoxProps) => (
  <Flex alignItems="center" flexWrap="wrap">
    <Box {...props} />
  </Flex>
);

export default SettingsTextContainer;
